
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent :overlay="false"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <h3 class="headline mb-0">Editando forma de recebimento</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <receipt-config-form :model="model" ref='receipt_config'></receipt-config-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text @click='close' color="error">Fechar</v-btn>
          <v-btn text @click='submitEdit' color="primary">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api/index.js';
import ReceiptConfigForm from '@/_backoffice/_registrations/components/shared/forms/ReceiptConfigForm.vue'

export default {
  name: 'DialogEditReceiptConfig',
  components: {
    ReceiptConfigForm,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: {}
    },
    MODEL_API: {
      type: String,
      default: "Model",
    },
    METHOD:{
      type: String,
      default: "update"
    }
  },
  data() {
    return {
      saving: false,
    }
  },
  methods: {
    close(){
      this.$emit('closeDialog', 'account')
    },
    submitEdit(){
      let model = this.$refs.receipt_config.local_model 
      model = this.genAccount(model)
      model.id = this.$route.params.id
      this.saving = true
      Api[this.MODEL_API].updateInfos(model).then(r=> r.data).then(d=>{
        this.successUpdated()
        this.$emit('updated', 'account')
      }).catch(err=> {
        this.addNotification({type: 'success',  msg: `Ocorreu um erro, forma de recebimento não foi atualizada.`})
        console.log({err});
      }).finally(()=>{
        this.saving = false
        this.closeDialog()
      })
    },
    genAccount(model) {
      model.id =  this.$route.params.id
      model.accounts_attributes = []
      const kinds = model.receipt_config.kinds?.length
        ? model.receipt_config.kinds
        : [model.receipt_config.kind]
      if (kinds.includes('deposit')) {
        model.accounts_attributes = [...model.accounts]
      }
      if (!kinds.includes('pix')) {
        model.receipt_config.pix_key_kind = null
        model.receipt_config.pix_key = null
      }
      model.receipt_config.kinds = kinds
      return model
    },
    mounted () {
      this.getBanks()
    },
    ...mapActions({
      getBanks: 'Bank/index',
      addNotification: 'Notification/add'
    })
  },
}
</script>